export const MOVEABLE_DRAGGABLE_AREA_CLASS = 'crop-moveable-draggable-area';
export const MOVEABLE_CROP_AREA_CLASS = 'crop-moveable-crop-area';
